export const LOCK_FEATURE_REQUEST = "LOCK_FEATURE_REQUEST";
export const LOCK_FEATURE_SUCCESS = "LOCK_FEATURE_SUCCESS";
export const LOCK_FEATURE_FAIL =    "LOCK_FEATURE_FAIL";
export const LOCK_FEATURE_RESET =    "LOCK_FEATURE_RESET";

export const UNLOCK_FEATURE_REQUEST = "UNLOCK_FEATURE_REQUEST";
export const UNLOCK_FEATURE_SUCCESS = "UNLOCK_FEATURE_SUCCESS";
export const UNLOCK_FEATURE_FAIL =    "UNLOCK_FEATURE_FAIL";
export const UNLOCK_FEATURE_RESET =    "UNLOCK_FEATURE_RESET";

export const GET_LOCK_LIST_REQUEST = "GET_LOCK_LIST_REQUEST";
export const GET_LOCK_LIST_SUCCESS = "GET_LOCK_LIST_SUCCESS";
export const GET_LOCK_LIST_FAIL =    "GET_LOCK_LIST_FAIL";



// AppLock Action Types
export const CREATE_APPLOCK_REQUEST = 'CREATE_APPLOCK_REQUEST';
export const CREATE_APPLOCK_SUCCESS = 'CREATE_APPLOCK_SUCCESS';
export const CREATE_APPLOCK_FAIL = 'CREATE_APPLOCK_FAIL';
export const CREATE_APPLOCK_RESET = 'CREATE_APPLOCK_RESET';

export const GET_ALL_APPLOCKS_REQUEST = 'GET_ALL_APPLOCKS_REQUEST';
export const GET_ALL_APPLOCKS_SUCCESS = 'GET_ALL_APPLOCKS_SUCCESS';
export const GET_ALL_APPLOCKS_FAIL = 'GET_ALL_APPLOCKS_FAIL';

export const UPDATE_ACCESS_FEATURES_REQUEST = 'UPDATE_ACCESS_FEATURES_REQUEST';
export const UPDATE_ACCESS_FEATURES_SUCCESS = 'UPDATE_ACCESS_FEATURES_SUCCESS';
export const UPDATE_ACCESS_FEATURES_FAIL = 'UPDATE_ACCESS_FEATURES_FAIL';
export const UPDATE_ACCESS_FEATURES_RESET = 'UPDATE_ACCESS_FEATURES_RESET';

export const DELETE_APPLOCK_REQUEST = 'DELETE_APPLOCK_REQUEST';
export const DELETE_APPLOCK_SUCCESS = 'DELETE_APPLOCK_SUCCESS';
export const DELETE_APPLOCK_FAIL = 'DELETE_APPLOCK_FAIL';
export const DELETE_APPLOCK_RESET = 'DELETE_APPLOCK_RESET';

export const CLEAR_ERRORS = 'CLEAR_ERRORS';